import { render, staticRenderFns } from "./SupportCalculator.vue?vue&type=template&id=468ece44&scoped=true"
import script from "./SupportCalculator.vue?vue&type=script&lang=js"
export * from "./SupportCalculator.vue?vue&type=script&lang=js"
import style0 from "./SupportCalculator.vue?vue&type=style&index=0&id=468ece44&prod&scoped=true&lang=css"
import style1 from "./SupportCalculator.vue?vue&type=style&index=1&id=468ece44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468ece44",
  null
  
)

export default component.exports